import { render, staticRenderFns } from "./ProfileAccountActions.vue?vue&type=template&id=487253f4"
import script from "./ProfileAccountActions.vue?vue&type=script&lang=js"
export * from "./ProfileAccountActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports